import { useContext } from "react";
import ConnectRetailer from "../../AppPages/Sync/Connect";
import { useSyncContext } from "../../../SyncProvider";
import { UserLoginContext } from "../UserLoginProvider";
import { getErrorMessage } from "../../../../utils/errors/errorUtils";

const OnBoardingConnect = () => {
  const { refreshSyncProvider } = useSyncContext();
  const { send, snapshot } = useContext(UserLoginContext);
  const connectedRetailerError = snapshot.context.errorMessage;
  const errorMessage = connectedRetailerError
    ? getErrorMessage({ error: connectedRetailerError })
    : undefined;

  const connectRetailerId = snapshot.context.connectRetailerId;

  return (
    <ConnectRetailer
      retailerId={connectRetailerId}
      errorMsg={errorMessage}
      onConnectCallback={async (retailerId) => {
        await refreshSyncProvider();
        send({
          type: "CONNECT_RETAILER_IN_PROGRESS",
          retailerId,
        });
      }}
      redirectToSync={false}
    />
  );
};

export default OnBoardingConnect;
